import { resource } from 'angular';
import { iGroup } from '@/interfaces/groups';

export interface IGroupsApiResource extends resource.IResourceClass<resource.IResource<iGroup>> {}

(function (angular) {
    'use strict';

    angular.module('app')
        .service('GroupsApi', GroupsApi);

    GroupsApi.$inject = [
        '$resource',
        'settings',
    ];

    /**
     * Provides an interface to the Categories API endpoints
     * 
     * @returns {Object}
     */
    function GroupsApi(
        $resource,
        settings
    ) {
        var resource = $resource(settings.apiBase + '/groups/:id', {
            id: '@id',
        }, {
            delete: {
                method: 'DELETE',
                responseType: 'json',
            },
            get: {
                method: 'GET',
                responseType: 'json',
            },
            post: {
                method: 'POST',
                responseType: 'json',
            },
            update: {
                method: 'PUT',
                responseType: 'json',
            },
            query: {
                isArray: true,
                method: 'GET',
                responseType: 'json',
                transformResponse: [
                    response => {
                        return response.data;
                    },
                ],
            },
            addUser: {
                method: 'POST',
                responseType: 'json',
                url: settings.apiBase + '/groups/:id/users'
            },
            GroupUserRequest: {
                method: 'POST',
                responseType: 'json',
                url: settings.apiBase + '/group-user-requests'
            },
            acceptRequest: {
                method: 'POST',
                responseType: 'json',
                url: settings.apiBase + '/group-user-requests/:id/accept'
            },
            declineRequest: {
                method: 'POST',
                responseType: 'json',
                url: settings.apiBase + '/group-user-requests/:id/decline'
            },
            removeUser: {
                method: 'DELETE',
                responseType: 'json',
                url: settings.apiBase + '/groups/:id/users'
            },
        });

        return resource;
    }
})(angular);
